import Echo from 'laravel-echo';
import axios from 'axios';

window.Pusher = require('pusher-js');

const params = {
  broadcaster: 'pusher',
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: 'eu',
  forceTLS: true,
};
window.echo = null;

function echoFactory(token) {
  if (!window.echo) {
    window.echo = new Echo({
      ...params,
      authorizer: (channel, options) => ({
        authorize: (socketId, callback) => {
          axios
            .post(
              '/broadcasting/auth',
              {
                socket_id: socketId,
                channel_name: channel.name,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: 'application/json',
                },
              }
            )
            .then((response) => {
              callback(false, response.data);
            })
            .catch((error) => {
              console.error(error);
              callback(true, error);
            });
        },
      }),
    });
  }
  return window.echo;
}

export default echoFactory;
